import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const LiveAvailability = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [tab, setTab] = useState("tab-1")
  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`live-availability py-60 mdscreen2:py-45 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-xl"
          >
            <div className="common-tabs">
              <div className="tabs-main">
                {module?.tabs && (
                  <motion.div
                    variants={animFade}
                    className="tab-link-wrapper overflow-x-auto w-full"
                  >
                    <ul className="flex justify-center items-center gap-x-25 tabs mdscreen:pt-15 xlscreen:w-max mx-auto">
                      {module?.tabs.map((item, i) => {
                        const tabId = `tab-${i + 1}`
                        return (
                          <li
                            key={i}
                            onClick={() => setTab(tabId)}
                            className={`cursor-pointer text-black-100 border ${
                              tab === tabId ? "active-tab" : ""
                            }`}
                            onKeyDown={() => setTab(tabId)}
                            aria-hidden="true"
                          >
                            {item.title}
                          </li>
                        )
                      })}
                    </ul>
                  </motion.div>
                )}
                <div className="tab-container pt-85 lgscreen:pt-60 mdscreen:pt-45">
                  {tab === "tab-1" && (
                    <div className="tab-container-main">
                      <div className="max-w-[911px] mx-auto">
                        <div className="flex flex-col items-center">
                          <motion.div
                            variants={animFade}
                            className="title title-green"
                          >
                            <h3 className="uppercase tracking-0.04em font-500">
                              All Camps & Lodges
                            </h3>
                          </motion.div>
                        </div>
                        <div className="pt-25">{parse(module.iframe)}</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default LiveAvailability
export const PageLiveAvailabilityFragment = graphql`
  fragment PageLiveAvailabilityFragment on WpPage_Pagecontent_PageContent_LiveAvailability {
    extraClass
    extraId
    hideSection
    iframe
    tabs {
      title
    }
  }
`
